
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 12 24","xmlns":"http://www.w3.org/2000/svg","fill-rule":"evenodd","clip-rule":"evenodd","stroke-linecap":"round","stroke-linejoin":"round","stroke-miterlimit":"1.5"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M44.511 20.366h-9.093L36.801 3.68h6.327l1.383 16.686z","fill":"none","stroke":"#000","stroke-width":"1.83","transform":"matrix(-1.07472 0 0 -.8859 48.737 21.729)"}}),_c('path',{attrs:{"d":"M39.747 1.287v2.772M39.747 19.951v2.62","fill":"none","stroke":"#000","stroke-width":"1.59","transform":"matrix(1.24832 0 0 1 -43.83 -.387)"}})])
          )
        }
      }
    